import { SET_SEARCH_DATA, CLEAR_SEARCH_DATA } from "../actions";

const INITIAL_STATE = [];

export default function searchData(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_SEARCH_DATA: {
      return action.payload;
    }
    case CLEAR_SEARCH_DATA: {
      return [];
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/searchData.js